export default {
    init() {
        this.timeCountDown();
    },

    timeCountDown() {

        $( ".time-countDown" ).each(function( index ) {
            let date =  $(this).attr("data-countDown");
            $(this).countdown(date, function(event) {
                $(this).html(event.strftime('%-Dd. %Hh %-Mmin'));
            });
        });
    },
}